const initialState = {
  // user interaction data
  acceptTermsConditions: false,
  accordionStatus: {
    features: false,
    isVisible: false,
    membership: false,
    questions: false,
    reviews: false,
    sizeChart: false,
    specs: false,
    userManuals: false
  },
  adobeTestData: [],
  analyticsConfig: {
    prefix: "rei:pdp_",
    siteId: "rei"
  },
  ariaLive: {
    message: "",
    politeness: "polite"
  },
  buyBoxValidation: {
    color: {
      hasError: false,
      el: null
    },
    fulfillment: {
      hasError: false,
      el: null
    },
    size: {
      hasError: false,
      el: null
    },
    quantity: {
      hasError: false,
      el: null
    },
    sku: {
      hasError: false,
      el: null
    },
    membership: {
      hasError: false,
      el: null
    },
    notifyMe: {
      hasError: false,
      el: null
    },
    pickupTile: {
      hasError: false,
      el: null
    },
    shipTile: {
      hasError: false,
      el: null
    }
  },
  cartData: {},
  cartErrorData: {},
  cartLoadState: false,
  cartLoadMembershipState: false,
  cartMicroserviceData: {},
  cartSummary: {},
  includeMembership: false,
  media: {
    currentImage: {},
    heroImage: {
      uri: "",
      index: 0
    },
    useVerticalAnimation: false
  },
  modalIsOpen: false,
  modalData: {
    label: "",
    modalContent: "",
    labelIsTitle: false,
    // modalProps can be a string or an object
    modalProps: null
  },
  modalContainer: null,
  selectedSize: "",
  tempSize: "",
  selectedColor: {},
  tempColor: {},
  selectedPrice: {},
  tempPrice: {},
  sizeFinderSelectedSize: {
    feet: "",
    inches: ""
  },
  sizeFinderResults: [],
  inventory: {
    loaded: false,
    skuMap: []
  },
  selectedSku: {
    size: "",
    color: {}
  },
  quantity: 1,
  shipping: {
    noStoreAvailable: false,
    noLocationAvailable: false,
    inlineEditorIsInvalid: false,
    inlineShippingEditorOpen: false,
    inlineLoading: false,
    hasNetworkError: false,
    shippingMethod: null,
    selectedStore: null,
    shippingAddress: {
      city: "",
      countryCode: "",
      latitude: "",
      longitude: "",
      postalCode: "",
      state: ""
    },
    shippingAvailability: {
      errorMessages: null,
      estimatedArrivalDate: "",
      estimatedArrivalTimestamp: null,
      fulfilledQuantity: 1,
      fulfillmentServiceLevel: "",
      fulfillmentType: "",
      hasErrors: null
    },
    orderIssues: []
  },
  isPickupModalStoreSet: false,
  userSelectedStoreData: {
    storeId: null,
    storeName: null,
    distance: null
  },
  storeData: {
    blueYonderResponseData: [],
    searchTerm: "",
    geoLocation: {
      lat: "",
      long: ""
    },
    allowsGeo: true,
    geoLocationError: {
      code: null,
      message: ""
    },
    fulfillmentError: "",
    isLoading: false,
    linkName: ""
  },
  storePickupValidation: {
    hasError: false,
    hasWarning: false,
    problemMessage: "",
    searchBoxEl: null
  },
  imageZoom: {
    buttonRef: null,
    showZoom: false,
    library: null
  },
  disclaimers: [],
  restrictions: [],
  richRelevance: {
    loaded: false,
    placements: {},
    hasError: false,
    component: null
  },
  bvReviews: {
    loaded: false,
    hasError: false
  },
  klarna: {
    loaded: false,
    hasError: false
  },
  wishlist: {
    selectedWishlist: {
      list: {
        id: "",
        name: ""
      }
    },
    allWishlists: [],
    hasError: false,
    errorCode: ""
  },
  user: {
    isLoggedIn: false,
    isMember: false,
    preferredStore: null
  },
  asyncComponentsMounted: {},
  // API data below
  akamaiTestSegment: "",
  analytics: {},
  appProps: {},
  buyingAdvice: {},
  curatedOutfitData: {
    default: {
      headingTop: "",
      headingBottom: "",
      authors: []
    }
  },
  messages: {
    freeShipping: {},
    promo: {
      priceOffer: {}
    },
    shippingRestrictions: null,
    shipUrgency: null
  },
  product: {
    anyOversizeCharges: false,
    anySkuShippingRestrictions: false,
    brand: {
      link: "",
      name: ""
    },
    storytelling: {},
    breadcrumbs: [],
    byColor: {},
    bySize: {},
    canonicalUrl: "",
    colors: [],
    description: "",
    displayOptions: {
      carouselOrientation: "",
      colorLabel: "",
      dividendEstimatedSavingsText: "",
      estimatedSavings: null,
      freeShipping: false,
      pupInfo: {
        isPup: false
      },
      sellingCopy: null,
      showAllDetailImages: null,
      showDividendMessage: null,
      showSkuDropDown: false,
      showTermsAndConditions: null,
      sizeLabel: ""
    },
    eligibleForShipping: true,
    features: [],
    hideOversizeMessaging: false,
    images: [],
    navCat: {
      categories: []
    },
    originCountry: "",
    oversizeCharges: [],
    productFeatures: [],
    relatedLinks: [],
    sizeChart: {},
    sizes: [],
    sizesV2: [],
    skus: [],
    skusForOption: {
      colors: {},
      sizes: {}
    },
    specifications: [],
    styleId: "",
    stylePrice: {
      hideDisplayPrice: false,
      maxCompareAt: {
        sale: false,
        status: "",
        value: null
      },
      maxPrice: {
        sale: false,
        status: "",
        value: null
      },
      minCompareAt: {
        sale: false,
        status: "",
        value: null
      },
      minPrice: {
        sale: false,
        status: "",
        value: null
      }
    },
    taxCat: {},
    techSpecs: [],
    title: "",
    userManuals: [],
    videos: [],
    productLineUrl: "",
    productLineUrlLabel: ""
  },
  sitkaData: {},
  ugcImageResponse: {},
  membershipAddedToCart: false,
  currentUgcProduct: null,
  urlSearchParams: {},
  userSubscription: null,
  notifyMe: {
    email: "",
    skusNotified: [],
    errorMessage: ""
  },
  viewedSkus: {}
};
export {
  initialState as default
};
//# sourceMappingURL=initialState.mjs.map
